import { Navigate } from "react-router-dom";
import { useAuth } from "../services/authService";
import {
  normalizeStatus,
  normalizeRole,
  canManageClients,
} from "../services/authz";

export default function AdminRoute({ children }) {
  const { currentUser, userRole, userStatus } = useAuth();

  if (!currentUser) return <Navigate to="/login" replace />;

  const status = normalizeStatus(userStatus);
  const role = normalizeRole(userRole);

  const isApproved = status === "approved" || status === "active";
  if (!isApproved) return <Navigate to="/registered" replace />;

  const allowed = canManageClients(status, role);
  if (!allowed) return <Navigate to="/dashboard" replace />;

  return children;
}
